import React from "react";
import styled from "styled-components";

const AuthWrapper = styled.section`
  min-height: 100vh;
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: #f2f4f8;
`;

export default ({ children }) => {
  return <AuthWrapper>{children}</AuthWrapper>;
};
